import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import html2pdf from 'html2pdf.js';
import Logo from '../assest/ecomlogo1.png';
import displayINRCurrency from '../helpers/displayCurrency';

const Invoice = () => {
    const location = useLocation();
    const { order } = location.state || {};
    const navigate = useNavigate();
    console.log(order);
    if (!order) {
        return <p>No order data available.</p>;
    }

    const handlePrint = () => {
        const element = document.getElementById('invoice-content');
        const options = {
            margin: 0.3,
            filename: `Invoice_${order.order_code}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 1.5 },
            jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
        };

        const style = document.createElement('style');
        style.innerHTML = `
            @media print {
                .no-print { display: none; }
                @page { size: A4; margin: 0.3in; }
                
                #invoice-content {
                    transform: scale(0.95);
                    transform-origin: top center;
                }
                
                p, td, th {
                    font-size: 11px !important;
                }
                
                table {
                    font-size: 11px !important;
                }
                
                .print-content { 
                    page-break-inside: avoid;
                    page-break-after: avoid;
                    page-break-before: avoid;
                }
                .text-center { text-align: center; }
            }
        `;
        document.head.appendChild(style);

        html2pdf().from(element).set(options).toPdf().get('pdf').then(pdf => {
            pdf.autoPrint();
            pdf.output('dataurlnewwindow');
        });

        setTimeout(() => {
            document.head.removeChild(style);
        }, 0);
    };

    const handleDownload = () => {
        const element = document.getElementById('invoice-content');
        const options = {
            margin: 0.3,
            filename: `Invoice_${order.order_code}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 1.5 },
            jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
        };
        html2pdf().from(element).set(options).save();
    };

    const handleEdit = (orderid) => {
        navigate('/admin-panel/edit-order', { state: { orderid } });
    };

    return (
        <div>
            <div className="print:hidden flex flex-col sm:flex-row justify-center space-y-2 sm:space-y-0 sm:space-x-2 mt-6">
                <div>
                    <button
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                        onClick={handlePrint}
                    >
                        Print
                    </button>
                    <button
                        className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded ml-2"
                        onClick={handleDownload}
                    >
                        Download
                    </button>
                </div>
                <div>
                    <button
                        className="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded md:ml-[100px]"
                        onClick={() => handleEdit(order.order_id)}
                    >
                        Order details
                    </button>
                </div>
            </div>
            
            {/* Inner paper with balanced spacing */}
            <div className="p-4 max-w-5xl mx-auto bg-white border my-3 border-gray-300 rounded-lg shadow-lg print-content" id="invoice-content">
                
                {/* Header Section */}
<div className="flex items-center justify-center mb-1">
    <img
        src={Logo}
        alt="AHA MART Logo"
        className="w-36 h-36 object-contain"
    />

    <div className="text-left -ml-3">
        <h1 className="text-3xl font-extrabold tracking-wider" style={{ color: '#f36c32' }}>
            AHA MART
        </h1>
<p className="text-gray-600 text-lg font-bold text-center mt-0">
    Vidya Nagar , Ponnuru - 522124
</p>
       

    </div>
</div>
<p className="text-gray-600 text-lg font-bold text-center mt-0">
    Invoice
</p>
                {/* Invoice Details */}
                <div className="mb-6 p-4 border border-gray-200 rounded-md">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                        <div className='flex justify-between border-b border-gray-300 pb-1'>
                            <p className="font-semibold">Invoice No:</p>
                            <p>{order.order_code}</p>
                        </div>
                        <div className='flex justify-between border-b border-gray-300 pb-1'>
                            <p className="font-semibold">Invoice Date:</p>
                            <p>{new Date().toLocaleDateString()}</p>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div className='flex justify-between border-b border-gray-300 pb-1'>
                            <p className="font-semibold">Order Date:</p>
                            <p>{new Date(order.order_date_time).toLocaleDateString()}</p>
                        </div>
                        <div className='flex justify-between border-b border-gray-300 pb-1'>
                            <p className="font-semibold">Order Amount:</p>
                            <p>{displayINRCurrency(order.order_amount)}</p>
                        </div>
                    </div>
                </div>

                {/* Address Sections */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-6">
                    <div className="p-4 border border-gray-200 rounded-md">
                        <h3 className="text-md font-semibold mb-3">Bill To:</h3>
                        <p className="text-sm mb-1">{order.customer_name}</p>
                        <p className="text-sm mb-1">{order.order_address}</p>
                        <p className="text-sm">{order.country}</p>
                    </div>
                    <div className="p-4 border border-gray-200 rounded-md">
                        <h3 className="text-md font-semibold mb-3">Ship To:</h3>
                        <p className="text-sm mb-1">{order.customer_name}</p>
                        <p className="text-sm mb-1">{order.order_address}</p>
                        <p className="text-sm">{order.country}</p>
                    </div>
                </div>

                {/* Products Table with Center Aligned Cells */}
                <div className="mb-6">
                    <h3 className="text-md font-semibold mb-3">Products</h3>
                    <div className="overflow-x-auto">
                        <table className="w-full border border-gray-300 border-collapse mb-4 text-sm">
                            <thead>
                                <tr className="bg-gray-100">
                                    <th className="border border-gray-300 p-2 text-left">Product</th>
                                    <th className="border border-gray-300 p-2 text-center">QTY</th>
                                    <th className="border border-gray-300 p-2 text-center">Price</th>
                                    <th className="border border-gray-300 p-2 text-center">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {order.order_items.map(item => (
                                    <tr key={item.order_items_id}>
                                        <td className="border border-gray-300 p-2 text-left align-middle">
                                            {item.product_name}
                                            {item.warranty && <p className="text-xs text-gray-600 mt-1">Warranty: {item.warranty}</p>}
                                        </td>
                                        <td className="border border-gray-300 p-2 text-center align-middle">{item.quantity}</td>
                                        <td className="border border-gray-300 p-2 text-center align-middle">{displayINRCurrency(item.price)}</td>
                                        <td className="border border-gray-300 p-2 text-center align-middle">{displayINRCurrency(item.subtotal)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Charges Summary */}
                    <div className="p-4 border border-gray-200 rounded-md bg-gray-50">
                        <div className="flex flex-col sm:flex-row justify-between mb-2 pb-1">
                            <p className="font-semibold">Delivery Charges:</p>
                            <p className="text-center sm:text-right">{displayINRCurrency(order.delivery_charges || '0.00')}</p>
                        </div>
                        <div className="flex flex-col sm:flex-row justify-between mb-2 pb-1">
                            <p className="font-semibold">GST Charges:</p>
                            <p className="text-center sm:text-right">{displayINRCurrency(order.gst_charges || '0.00')}</p>
                        </div>
                        <div className="flex flex-col sm:flex-row justify-between mb-2 pb-1">
                            <p className="font-semibold">Other Charges:</p>
                            <p className="text-center sm:text-right">{displayINRCurrency(order.other_charges || '0.00')}</p>
                        </div>
                        <div className="flex flex-col sm:flex-row justify-between font-semibold pt-2 border-t-2 border-gray-300 mt-1">
                            <p className="text-base">Total Amount:</p>
                            <p className="text-base text-center sm:text-right text-[#f36c32]">{displayINRCurrency(order.total_amount)}</p>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="text-center mt-6 pt-4 border-t border-gray-200">
                    <p className="mb-3 text-lg font-semibold" style={{ color: '#f36c32' }}>Thank You!</p>
                    <p className="text-sm text-gray-600 mb-2">For Shopping with us</p>
                    <p className="text-sm text-gray-600 mb-2">
                        We truly appreciate your trust and support.
                    </p>
                    <p className="text-sm text-gray-600">Helpline: +91 9676699692</p>
                    <p className="text-sm text-gray-600">Email: ahamartponnur@gmail.com</p>
                    
                </div>
            </div>
        </div>
    );
};

export default Invoice;